import { createSlice } from '@reduxjs/toolkit';
import { updateFeatureControlApi } from '../../../rtk-apis/clinics/updateFeatureControl';

const initialState = {
  status: '',
  result: null as any,
  msg: '',
  loading: false,
};

const updateFeatureControlSlice = createSlice({
  name: 'updateFeatureControl',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(updateFeatureControlApi.pending, state => {
        state.loading = true;
      })
      .addCase(updateFeatureControlApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload;
        state.msg = (action?.payload as any)?.msg || '';
      })
      .addCase(updateFeatureControlApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.result = null;
        state.msg = (action?.payload as string) || 'Something went wrong!';
      });
  },
});

export default updateFeatureControlSlice.reducer;
export const { clearState } = updateFeatureControlSlice.actions;
